export const NAVIGATE_TO = 'ROUTER/NAVIGATE';
export const CANCEL_TRANSITION = 'ROUTER/CANCEL';
export const TRANSITION_ERROR = 'ROUTER/TRANSITION_ERROR';
export const TRANSITION_SUCCESS = 'ROUTER/TRANSITION_SUCCESS';
export const TRANSITION_START = 'ROUTER/TRANSITION_START';
export const CLEAR_ERRORS = 'ROUTER/CLEAR_ERRORS';
export const CAN_DEACTIVATE = 'ROUTER/CAN_DEACTIVATE';
export const CAN_ACTIVATE = 'ROUTER/CAN_ACTIVATE';
